import { Link } from "react-router-dom";
import { MessageCircle, Phone, Mail, MapPin, Satellite, ArrowUpRight } from "lucide-react";
import { openWhatsApp, PHONE_DISPLAY, EMAIL, ADDRESS } from "../../lib/whatsapp";
import { useT } from "../../lib/i18n";

export const Footer = () => {
    const t = useT();
    return (
        <footer className="bg-[#0A1128] text-white" data-testid="site-footer">
            <div className="max-w-7xl mx-auto px-6 md:px-12 py-20 md:py-28">
                <div className="grid md:grid-cols-12 gap-12 md:gap-8">
                    <div className="md:col-span-7">
                        <p className="eyebrow text-[#FF5A00]">{t("Ready to partner?", "భాగస్వామిగా చేరదామా?")}</p>
                        <h2 style={{fontFamily: "'Outfit', 'Noto Sans Telugu', sans-serif"}} className="text-4xl sm:text-5xl md:text-6xl font-black tracking-tighter mt-4 leading-[1.05] text-white">
                            {t("Let's bring Sun Direct to your home or shop.", "మీ ఇంటికి లేదా షాపుకు సన్ డైరెక్ట్‌ను తీసుకువద్దాం.")}
                        </h2>
                        <button
                            onClick={() => openWhatsApp(t("Hello RVS Electronics, I'd like to know more about your services.", "హలో RVS ఎలక్ట్రానిక్స్, మీ సేవల గురించి తెలుసుకోవాలనుకుంటున్నాను."))}
                            data-testid="footer-whatsapp-btn"
                            className="mt-8 btn-orange inline-flex items-center gap-2 px-6 py-3.5 rounded-full text-sm font-semibold"
                        >
                            <MessageCircle className="w-4 h-4" /> {t("Chat on WhatsApp", "వాట్సాప్‌లో చాట్ చేయండి")} <ArrowUpRight className="w-4 h-4" />
                        </button>
                    </div>

                    <div className="md:col-span-5 grid grid-cols-2 gap-8 text-sm">
                        <div>
                            <p className="eyebrow text-white/50">{t("Navigate", "నావిగేట్")}</p>
                            <ul className="mt-4 space-y-2.5 text-white/80">
                                <li><Link className="hover:text-[#FF5A00]" to="/" data-testid="footer-link-home">{t("Home", "హోమ్")}</Link></li>
                                <li><Link className="hover:text-[#FF5A00]" to="/about" data-testid="footer-link-about">{t("About", "మా గురించి")}</Link></li>
                                <li><Link className="hover:text-[#FF5A00]" to="/services" data-testid="footer-link-services">{t("Services", "సేవలు")}</Link></li>
                                <li><Link className="hover:text-[#FF5A00]" to="/retailers" data-testid="footer-link-retailers">{t("For Retailers", "రిటైలర్ల కోసం")}</Link></li>
                                <li><Link className="hover:text-[#FF5A00]" to="/coverage" data-testid="footer-link-coverage">{t("Coverage", "సేవా ప్రాంతం")}</Link></li>
                                <li><Link className="hover:text-[#FF5A00]" to="/contact" data-testid="footer-link-contact">{t("Contact", "సంప్రదించండి")}</Link></li>
                            </ul>
                        </div>
                        <div>
                            <p className="eyebrow text-white/50">{t("Reach Us", "సంప్రదింపు")}</p>
                            <ul className="mt-4 space-y-3 text-white/80">
                                <li className="flex items-start gap-2"><Phone className="w-4 h-4 mt-0.5 text-[#FF5A00]" /> <a href="tel:+918341717181" className="hover:text-white" data-testid="footer-phone">{PHONE_DISPLAY}</a></li>
                                <li className="flex items-start gap-2"><Mail className="w-4 h-4 mt-0.5 text-[#FF5A00]" /> <a href={`mailto:${EMAIL}`} className="hover:text-white break-all" data-testid="footer-email">{EMAIL}</a></li>
                                <li className="flex items-start gap-2"><MapPin className="w-4 h-4 mt-0.5 text-[#FF5A00]" /> <span className="leading-relaxed">{ADDRESS}</span></li>
                            </ul>
                        </div>
                    </div>
                </div>

                <div className="mt-16 pt-8 border-t border-white/10 flex flex-col md:flex-row md:items-center justify-between gap-4 text-xs text-white/50">
                    <div className="flex items-center gap-2">
                        <span className="w-7 h-7 rounded-md bg-[#FF5A00] flex items-center justify-center">
                            <Satellite className="w-4 h-4 text-white" />
                        </span>
                        <span>© {new Date().getFullYear()} RVS Electronics — {t("Authorized Distributor of Sun Direct.", "సన్ డైరెక్ట్ అధికారిక డిస్ట్రిబ్యూటర్.")}</span>
                    </div>
                    <div className="flex items-center gap-5">
                        <Link to="/privacy" data-testid="footer-link-privacy" className="hover:text-white">{t("Privacy Policy", "గోప్యతా విధానం")}</Link>
                        <Link to="/terms" data-testid="footer-link-terms" className="hover:text-white">{t("Terms & Conditions", "నిబంధనలు & షరతులు")}</Link>
                    </div>
                </div>
                <p className="mt-4 text-xs text-white/40 md:text-right">{t("Armoor, Nizamabad District, Telangana · Service radius 40 km.", "ఆర్మూర్, నిజామాబాద్ జిల్లా, తెలంగాణ · సేవా పరిధి 40 కిమీ.")}</p>
            </div>
        </footer>
    );
};
